import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, Link as RouterLink, redirect } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Container,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
  CardActions,
  Chip,
  // CircularProgress, // YORUM SATIRINA ALINDI - artık loading overlay yok
  IconButton,
  Paper,
  TextField,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import { motion } from 'framer-motion'; // AnimatePresence kaldırıldı - artık loading overlay yok
import { servicesData } from '../data/mockData';

// ESKI IMPORT - YORUM SATIRINA ALINDI (robot ikonu kaldırıldı)
// import SmartToyIcon from '@mui/icons-material/SmartToy';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
// POC Banner için kullanılıyor
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

// JSON tabanlı yerel depolama kullanımı
const saveDataToLocalStorage = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
    console.log(`Data saved to local storage with key: ${key}`);
    return true;
  } catch (error) {
    console.error('Error saving to local storage:', error);
    return false;
  }
};

const loadDataFromLocalStorage = (key) => {
  try {
    const savedData = localStorage.getItem(key);
    if (savedData) {
      const parsedData = JSON.parse(savedData);
      console.log(`Data loaded from local storage with key: ${key}`, parsedData);
      return parsedData;
    }
    return [];
  } catch (error) {
    console.error('Error loading from local storage:', error);
    return [];
  }
};

const Home = () => {
  const navigate = useNavigate();
  // Yeni kategori sistemi: 'all', 'products', 'solutions'
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [loading, setLoading] = useState(false);
  const iframeRef = useRef(null);

  // ESKI KOD - YORUM SATIRINA ALINDI (gelecekte kullanım için)
  // const [selectedCategory, setSelectedCategory] = useState('AI');
  // AI hizmetleri
  // const aiServices = servicesData; // Tüm hizmetleri göster

  // Yeni sistem - tüm servisleri göster
  const allServices = servicesData;

  // ESKI KOD - YORUM SATIRINA ALINDI (gelecekte kullanım için)
  // Kategori seçimi - AI kategorisi otomatik seçili
  // const handleCategorySelect = (category = 'AI') => {
  //   setLoading(true);
  //   setSelectedCategory('AI');
  //   
  //   // AI hizmetleri gösterilecek
  //   setTimeout(() => {
  //     document.getElementById('services-section')?.scrollIntoView({ behavior: 'smooth' });
  //     setLoading(false);
  //   }, 500);
  // };

  // Yeni kategori seçim fonksiyonu
  const handleCategorySelect = (category = 'all') => {
    setLoading(true);
    setSelectedCategory(category);

    // Seçilen kategoriye göre hizmetleri göster
    setTimeout(() => {
      document.getElementById('services-section')?.scrollIntoView({ behavior: 'smooth' });
      setLoading(false);
    }, 500);
  };

  // Hizmete tıklandığında ilgili sayfaya yönlendir
  const handleServiceClick = (path) => {
    navigate(path);
  };

  // Iframe yüklenmesi durumunda
  const handleIframeLoad = () => {
    setLoading(false);
  };

  // Sayfa yüklendiğinde animasyonlar için useEffect
  useEffect(() => {
    // Sayfa yüklendiğinde loading state'ini false yap
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // Yeni state ve fonksiyonlar - gelecekteki kullanım için
  const [isAddingItem, setIsAddingItem] = useState(false);
  const [newItemData, setNewItemData] = useState({
    title: '',
    description: '',
    url: ''
  });

  // Form alanı değişikliği izleyicisi
  const handleFormChange = (field, value) => {
    setNewItemData(prev => ({ ...prev, [field]: value }));
  };

  // Menü yönetimi için state'ler
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  // Menüyü aç
  const handleMenuClick = (event, index) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
    setSelectedItemIndex(index);
  };

  // Menüyü kapat
  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedItemIndex(null);
  };

  // Düzenlemeyi başlat
  const handleEditItem = () => {
    const itemToEdit = allServices[selectedItemIndex];
    if (itemToEdit) {
      setNewItemData({
        title: itemToEdit.title,
        description: itemToEdit.description || '',
        url: itemToEdit.path || ''
      });
      setIsEditing(true);
      setIsAddingItem(true);
    }
    handleMenuClose();
  };

  // Silme onayı dialog'unu göster
  const handleDeleteConfirm = () => {
    setShowDeleteConfirm(true);
    handleMenuClose();
  };

  // Item silme işlemi
  const handleDeleteItem = () => {
    try {
      console.log(`Deleting item at index: ${selectedItemIndex}`);
      setShowDeleteConfirm(false);
    } catch (error) {
      console.error('Error deleting item:', error);
      alert('Item silinirken bir hata oluştu. Lütfen tekrar deneyin.');
    }
  };

  // Form iptal etme işleyicisi
  const handleCancelForm = () => {
    setNewItemData({ title: '', description: '', url: '' });
    setIsAddingItem(false);
    setIsEditing(false);
  };

  // Form submit işleyicisi
  const handleSubmitForm = async (e) => {
    e.preventDefault();

    if (newItemData.title && newItemData.url) {
      try {
        setLoading(true);

        if (isEditing) {
          console.log('Updating item:', newItemData);
        } else {
          console.log('Adding new item:', newItemData);
        }

        // Formu sıfırla ve kapat
        setNewItemData({ title: '', description: '', url: '' });
        setIsAddingItem(false);
        setIsEditing(false);

      } catch (error) {
        console.error('Error submitting form:', error);
        alert('İşlem sırasında bir hata oluştu. Lütfen tekrar deneyin.');
      } finally {
        setLoading(false);
      }
    }
  };
  const handleContactClick = () => {
    navigate('/contact');
  };

  // AI POC sayfasına yönlendirme
  const handlePocButtonClick = () => {
    navigate('/services/ai-poc-demo');
  };

  // ESKI KOD - YORUM SATIRINA ALINDI (Hero bölümü kaldırıldı)
  // Hero section'daki kategoriye tıklama
  // const handleHeroClick = () => {
  //   handleCategorySelect('all'); // Tüm kategorileri göster
  // };

  return (
    <Box sx={{
      minHeight: 'calc(100vh - 70px)',
      overflow: 'hidden',
      position: 'relative',
      pt: 4 // Hero kaldırıldığı için üst padding eklendi
    }}>
      {/* ESKI HERO BÖLÜMÜ - YORUM SATIRINA ALINDI (tema değişikliği nedeniyle kaldırıldı)
      <Box sx={{
        height: 'calc(100vh - 70px)',
        display: 'flex',
        position: 'relative',
      }}>
        <Box
          component={motion.div}
          initial={{ x: 0, opacity: 0.8 }}
          animate={{
            x: 0,
            opacity: 1,
            width: selectedCategory === 'AI' ? '100%' : '100%'
          }}
          transition={{ duration: 0.5 }}
          onClick={handleHeroClick}
          sx={{
            height: '100%',
            background: `linear-gradient(135deg, rgba(30, 41, 59, 0.95), rgba(63, 81, 181, 0.85))`,
            backgroundImage: `url('https://images.unsplash.com/photo-1677442135309-db06d6ea0980?q=80&w=1932&auto=format&fit=crop')`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            overflow: 'hidden',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            transition: 'all 0.5s ease-in-out',
            '&:hover': {
              transform: 'scale(1.01)',
            },
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(30, 41, 59, 0.8)',
              zIndex: 1
            }
          }}
        >
          <Box sx={{ position: 'relative', zIndex: 2, textAlign: 'center', p: 4, maxWidth: 600 }}>
            <motion.div
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.4, duration: 0.8 }}
            >
              <Typography variant="h1" component="h1" sx={{
                fontWeight: 700,
                mb: 2,
                fontSize: { xs: '2.5rem', sm: '3rem', md: '3.5rem' }
              }}>
                D-CAT AI
              </Typography>
            </motion.div>

            <motion.div
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.6, duration: 0.8 }}
            >
              <Typography variant="h5" sx={{ mb: 4, opacity: 0.9, lineHeight: 1.4 }}>
                Ürünlerimiz ve yapay zeka çözümlerimiz ile dijital dönüşümünüzü hızlandırın
              </Typography>
            </motion.div>

            <motion.div
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.8, duration: 0.8 }}
            >
              <Button
                variant="outlined"
                size="large"
                color="inherit"
                endIcon={<ArrowForwardIcon sx={{ transform: 'rotate(90deg)' }} />}
                sx={{
                  borderWidth: 2,
                  px: 4,
                  py: 1.5,
                  fontSize: '1.1rem',
                  '&:hover': {
                    borderWidth: 2,
                    bgcolor: 'rgba(255,255,255,0.1)',
                    transform: 'translateY(-2px)'
                  }
                }}
              >
                Ürün ve Çözümlerimizi Keşfedin
              </Button>
            </motion.div>
          </Box>
        </Box>
      </Box>
      */}      {/* ESKI LOADING OVERLAY - YORUM SATIRINA ALINDI (gereksiz yere yer kaplıyordu)
      <AnimatePresence>
        {loading && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(255,255,255,0.8)',
              zIndex: 9999
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <CircularProgress size={60} sx={{ color: 'rgb(63, 81, 181)' }} />
              <Typography variant="h6" sx={{ mt: 2, color: 'rgb(63, 81, 181)', fontWeight: 500 }}>
                Yükleniyor...
              </Typography>
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
      */}

      {/* ESKI KOD - YORUM SATIRINA ALINDI (gelecekte kullanım için)
      {selectedCategory === 'AI' && ( */}

      {/* D-CAT Ürün ve Çözümleri Bölümü */}
      <Box
        id="services-section"
        component={motion.div}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        sx={{
          py: 8,
          bgcolor: 'rgba(63, 81, 181, 0.03)',
          borderTop: 1,
          borderColor: 'rgba(63, 81, 181, 0.2)',
        }}
      >
        <Container maxWidth="lg">
          {/* Kategori Seçim Butonları */}
          <Box sx={{ mb: 6, textAlign: 'center' }}>
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.6 }}
            >
              <Typography
                variant="h3"
                component="h2"
                gutterBottom
                sx={{
                  fontWeight: 700,
                  color: 'rgb(63, 81, 181)',
                  mb: 4
                }}
              >
                D-CAT Ürün ve Çözümleri
              </Typography>

              {/* Kategori Seçim Butonları */}
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 4, flexWrap: 'wrap' }}>
                <Button
                  variant={selectedCategory === 'all' ? 'contained' : 'outlined'}
                  onClick={() => handleCategorySelect('all')}
                  sx={{ px: 3, py: 1 }}
                >
                  Tümü
                </Button>
                <Button
                  variant={selectedCategory === 'products' ? 'contained' : 'outlined'}
                  onClick={() => handleCategorySelect('products')}
                  sx={{ px: 3, py: 1 }}
                >
                  D-CAT Ürünler
                </Button>
                <Button
                  variant={selectedCategory === 'solutions' ? 'contained' : 'outlined'}
                  onClick={() => handleCategorySelect('solutions')}
                  sx={{ px: 3, py: 1 }}
                >
                  Yapay Zeka Çözümleri
                </Button>
              </Box>
            </motion.div>

            {/* ESKI KOD - YORUM SATIRINA ALINDI (gelecekte kullanım için)
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto' }}>
                Verilerinizden değer yaratarak işletmenizi güçlendiren yapay zeka ve makine öğrenmesi çözümleri
              </Typography>
            </motion.div>
            */}

            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto' }}>
                İhtiyacınıza özel ürün ve çözümlerle dijital dönüşümünüzde yanınızdayız
              </Typography>
            </motion.div>
          </Box>

          {/* AI POC Banner */}
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.6 }}
          >
            <Paper
              elevation={0}
              sx={{
                p: 3,
                mt: 2,
                mb: 4,
                borderRadius: 4,
                background: 'linear-gradient(90deg, #9c27b0 0%, #673ab7 100%)',
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
                justifyContent: 'space-between',
                color: 'white',
                position: 'relative',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-2px)'
                }
              }}
              onClick={handlePocButtonClick}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: -10,
                  right: -10,
                  width: { xs: 120, md: 200 },
                  height: { xs: 120, md: 200 },
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  zIndex: 0
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: -20,
                  left: -20,
                  width: { xs: 150, md: 250 },
                  height: { xs: 150, md: 250 },
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255,255,255,0.05)',
                  zIndex: 0
                }}
              />

              <Box sx={{ zIndex: 1, flexGrow: 1, mr: { xs: 0, md: 4 }, mb: { xs: 2, md: 0 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <AutoFixHighIcon sx={{ mr: 1 }} />
                  <Typography variant="overline" fontWeight="bold">
                    YAPAY ZEKA POC ÇALIŞMASI
                  </Typography>
                </Box>
                <Typography variant="h5" component="h2" fontWeight="bold" gutterBottom>
                  Zaman Serisi Tahminleme Modeli
                </Typography>
                <Typography variant="body1">
                  Yapay zeka ve makine öğrenmesi ile zaman serisi verilerinde gelecek tahminleme POC çalışması
                </Typography>
              </Box>

              <Button
                variant="outlined"
                size="large"
                endIcon={<ArrowForwardIcon />}
                onClick={handlePocButtonClick}
                sx={{
                  bgcolor: 'transparent',
                  color: 'white',
                  borderColor: 'white',
                  borderWidth: 2,
                  fontWeight: 'bold',
                  px: 3,
                  py: 1.5,
                  '&:hover': {
                    bgcolor: 'rgba(255,255,255,0.15)',
                    borderColor: 'white',
                    borderWidth: 2,
                  },
                  zIndex: 1
                }}
              >
                POC'u İncele
              </Button>
            </Paper>
          </motion.div>

          {/* Form Ekleme Alanı */}
          {isAddingItem && (
            <Grid item xs={12} sx={{ mb: 4 }}>
              <Paper
                component={motion.div}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                sx={{ p: 3, borderRadius: 2 }}
              >
                <Typography variant="h6" sx={{ mb: 2, color: 'rgb(63, 81, 181)' }}>
                  {isEditing ? 'Item Düzenle' : 'Yeni Item Ekle'}
                </Typography>

                <Box component="form" onSubmit={handleSubmitForm} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <TextField
                    required
                    label="Başlık"
                    variant="outlined"
                    fullWidth
                    value={newItemData.title}
                    onChange={(e) => handleFormChange('title', e.target.value)}
                    sx={{ mb: 2 }}
                  />

                  <TextField
                    label="Açıklama"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={2}
                    value={newItemData.description}
                    onChange={(e) => handleFormChange('description', e.target.value)}
                    sx={{ mb: 2 }}
                  />

                  <TextField
                    required
                    label="URL"
                    variant="outlined"
                    fullWidth
                    placeholder="URL'yi buraya yapıştırın"
                    value={newItemData.url}
                    onChange={(e) => handleFormChange('url', e.target.value)}
                    sx={{ mb: 3 }}
                  />

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button
                      variant="outlined"
                      color="inherit"
                      onClick={handleCancelForm}
                    >
                      İptal
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                    >
                      {isEditing ? 'Güncelle' : 'Ekle'}
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          )}

          {/* Hizmet Kartları */}
          <Grid container spacing={4} justifyContent="center">
            {allServices
              .filter(service => {
                if (selectedCategory === 'all') return true;
                if (selectedCategory === 'products') return service.category === 'D-CAT Ürün';
                if (selectedCategory === 'solutions') return service.category === 'Yapay Zeka Çözümü';
                return true;
              })
              .map((service, index) => (
                <Grid item key={service.id} xs={12} sm={6} md={4} lg={3}>
                  <Card
                    component={motion.div}
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 * index, duration: 0.6 }}
                    whileHover={{
                      scale: 1.03,
                      boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                    }}
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: 2,
                      overflow: 'hidden',
                      boxShadow: 2,
                      transition: 'all 0.3s',
                      position: 'relative'
                    }}
                  >
                    {/* Menü butonu - gösterim amaçlı */}
                    <IconButton
                      sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        bgcolor: 'rgba(255,255,255,0.8)',
                        zIndex: 2,
                        opacity: 0,
                        transition: 'opacity 0.3s',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.9)',
                        },
                        '.MuiCard-root:hover &': {
                          opacity: 1
                        }
                      }}
                      size="small"
                      onClick={(e) => handleMenuClick(e, index)}
                    >
                      <MoreVertIcon />
                    </IconButton>

                    <CardActionArea
                      onClick={() => handleServiceClick(service.path)}
                      sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
                    >
                      <CardMedia
                        component="img"
                        height="160"
                        image={service.image}
                        alt={service.title}
                        sx={{
                          transition: 'transform 0.3s ease',
                          '&:hover': {
                            transform: 'scale(1.05)'
                          }
                        }}
                      />
                      <CardContent sx={{ flexGrow: 1, pb: 3 }}>
                        <Chip
                          label={service.category}
                          size="small"
                          sx={{
                            mb: 1,
                            bgcolor: 'rgba(63, 81, 181, 0.1)',
                            color: 'rgb(63, 81, 181)',
                          }}
                        />
                        <Typography gutterBottom variant="h6" component="h2" sx={{ fontWeight: 600 }}>
                          {service.title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {service.description}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
          </Grid>
        </Container>
      </Box>

      {/* Ücretsiz Demo Talep Et CTA */}
      <Box
        id="contact-section"
        component={motion.div}
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        sx={{
          py: { xs: 8, md: 12 },
          background: 'linear-gradient(180deg, #0b1426 0%, #0a1020 100%)',
          textAlign: 'center'
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="h2"
            sx={{
              fontWeight: 800,
              color: '#ffffff',
              mb: 3,
              fontSize: { xs: '2rem', sm: '2.75rem', md: '3.5rem' },
              textShadow: '2px 0 0 rgba(255,60,80,0.55), -2px 0 0 rgba(60,170,255,0.55)',
              letterSpacing: '-0.5px'
            }}
          >
            Ücretsiz Demo Talep Et
          </Typography>
          <Typography
            sx={{
              color: 'rgba(255,255,255,0.72)',
              maxWidth: 720,
              mx: 'auto',
              mb: 5,
              fontSize: { xs: '1rem', md: '1.125rem' },
              lineHeight: 1.7
            }}
          >
            Yapay zeka çözümlerimizin işletmenize katacağı değeri birlikte keşfedelim. Hemen bizimle iletişime geçin ve uzman ekibimizden demo talep edin.
          </Typography>
          <Button
            size="large"
            endIcon={<ArrowForwardIcon />}
            onClick={() => window.open('https://dcat.com.tr/classic/tr/iletisim', '_blank')}
            sx={{
              px: 5,
              py: 1.75,
              fontSize: '1.05rem',
              fontWeight: 700,
              color: '#fff',
              borderRadius: 999,
              textTransform: 'none',
              background: 'linear-gradient(90deg, #3b5cff 0%, #6a4cff 100%)',
              boxShadow: '0 0 40px rgba(79, 92, 255, 0.55), 0 8px 24px rgba(0,0,0,0.35)',
              transition: 'transform 0.25s ease, box-shadow 0.25s ease',
              '&:hover': {
                background: 'linear-gradient(90deg, #4a6bff 0%, #7a5cff 100%)',
                boxShadow: '0 0 55px rgba(106, 76, 255, 0.7), 0 10px 28px rgba(0,0,0,0.4)',
                transform: 'translateY(-2px)'
              }
            }}
          >
            Hemen Başlayın
          </Button>
        </Container>
      </Box>

      {/* Dropdown Menü */}
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleEditItem}>
          <EditIcon fontSize="small" sx={{ mr: 1 }} /> Düzenle
        </MenuItem>
        <MenuItem onClick={handleDeleteConfirm} sx={{ color: '#f44336' }}>
          <DeleteIcon fontSize="small" sx={{ mr: 1 }} /> Sil
        </MenuItem>
      </Menu>

      {/* Silme Onay Dialog */}
      <Dialog
        open={showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(false)}
      >
        <DialogTitle>Item'ı Sil</DialogTitle>
        <DialogContent>
          <Typography>
            Bu item'ı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowDeleteConfirm(false)} color="inherit">İptal</Button>
          <Button onClick={handleDeleteItem} color="error" variant="contained" autoFocus>
            Evet, Sil
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Home;